const formatFilterHandler = () => {
  const filter = document.querySelector('[data-filter="format"]');

  if (!filter) return;

  const form = document.querySelector('form[name="arFilter_form"]');
  const resetBtn = filter.querySelector('[data-filter="reset"]');
  const checkboxes = filter.querySelectorAll('input[type="checkbox"]');

  if (!resetBtn || !checkboxes.length) return;

  const updateResetVisibility = () => {
    const anyChecked = Array.from(checkboxes).some(
      (checkbox) => checkbox.checked
    );
    resetBtn.style.display = anyChecked ? 'inline-flex' : 'none';
  };

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateResetVisibility);
  });

  resetBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    checkboxes.forEach((cb) => {
      if (cb.checked) {
        cb.checked = false;
        cb.dispatchEvent(new Event('click'));
      }
    });
    form.dispatchEvent(new Event('change'));
    updateResetVisibility();
  });

  updateResetVisibility();
};

export {formatFilterHandler};
